<template>
  <v-menu
    bottom
    left
    v-if="account.role != 'admin' && $route.name == 'chatting'"
  >
    <v-btn slot="activator" icon dark>
      <v-icon>{{changeView.icone}}</v-icon>
    </v-btn>
    <v-list>
      <v-list-tile v-for="(vuePupitre, i) in vuePupitre" :key="i" @click="changeViewPupitre(vuePupitre.value)">
        <v-icon>{{ vuePupitre.icone }}</v-icon>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      vuePupitre: [
        { value: 1, icone: 'mdi-numeric-1-box-multiple-outline' },
        { value: 2, icone: 'mdi-numeric-2-box-multiple-outline' },
        { value: 4, icone: 'mdi-numeric-4-box-multiple-outline' }
      ]
    }
  },

  mounted () {
  },

  methods: {
    changeViewPupitre (data) {
      this.$store.commit('_StoreWatcheeBox/CHANGE_VIEW_PUPITRE', data)
    }
  },

  watch: {
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['pupitreViewStatus']),
    ...mapGetters('_User', ['account']),
    changeView () {
      let selectedView = this.vuePupitre.find(p => this.pupitreViewStatus === p.value)
      this.$cookie.set('wz-pupitreView', selectedView.value, { expires: '1Y' })
      return selectedView
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzPupitreStatus.vue